import React, { useEffect } from 'react';
import { LeftContent } from '../common';
// import { useTranslation } from 'react-i18next';
// import { Link, useLocation } from 'react-router-dom';
// import { getPathLanguage } from '../../../utils/params';
// import { isMobile } from '../../../utils/constants';
import { RightContent } from '../common';
import { Breadcrumb } from '../common';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';

const BlogDetail = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb />
      <div className="section-block background-gray section-page-content">
        <div className="container">
          <div className="post-content-detail content-padding-top ">
            <div className="row">
              <LeftContent showLoader={showLoader} hideLoader={hideLoader} />
              <RightContent showLoader={showLoader} hideLoader={hideLoader} />
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default BlogDetail;
